import { Box } from '@wix/design-system';
import React from 'react';

export function BorderOnlyBox() {
  return (
    <Box
      width="100%"
      borderTopColor="D60"
      borderTopWidth="1px"
      borderTopStyle="solid"
      boxSizing="border-box"
    />
  );
}
